module.exports = __webpack_public_path__ + "static/media/CT360-LOGO-RBG_CT360.4393f78c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CT360-LOGO-RBG_CT360.png
// module id = 1360
// module chunks = 0